"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemText = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var utils_1 = require("../../utils");

var Primary = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1rem;\n  margin: 0;\n"], ["\n  font-size: 1rem;\n  margin: 0;\n"])));
var Secondary = styled_components_1.default.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.875rem;\n  margin: 0;\n"], ["\n  font-size: 0.875rem;\n  margin: 0;\n"])));
var StyledText = styled_components_1.default.div(function (_a) {
  var theme = _a.theme,
      isMultiline = _a.isMultiline,
      variant = _a.variant,
      size = _a.size;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'ListItemText', variant, size);
  return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      flex: 1 1 auto;\n      min-width: 0;\n      margin-top: 4px;\n      margin-bottom: 4px;\n\n      ", "\n\n      ", "\n    "], ["\n      flex: 1 1 auto;\n      min-width: 0;\n      margin-top: 4px;\n      margin-bottom: 4px;\n\n      ", "\n\n      ", "\n    "])), isMultiline && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          margin-top: 6px;\n          margin-bottom: 6px;\n        "], ["\n          margin-top: 6px;\n          margin-bottom: 6px;\n        "]))), themeStyles);
});

exports.ListItemText = function (_a) {
  var children = _a.children,
      primaryProp = _a.primary,
      secondaryProp = _a.secondary;
  var primary = primaryProp != null ? React.createElement(Primary, null, primaryProp) : children;
  var secondary = secondaryProp && React.createElement(Secondary, null, secondaryProp);
  var isMultiline = !!primary && !!secondary;
  return React.createElement(StyledText, {
    isMultiline: isMultiline
  }, primary, secondary);
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;